import { useDroppable } from "@dnd-kit/core"

export default function Droppable({ id, children, className }) {
  const { setNodeRef } = useDroppable({
    id: id,
  })
  return (
    <div
      style={{ width: "100%", height: "100%" }}
      ref={setNodeRef}
      className={className}
    >
      {children}
    </div>
  )
}
